import React, { useEffect, useState, useRef } from "react";
import { throttle } from "lodash";

//CSS
import "./filter.css";

//Components
import Button from "./button";
import FilterIcon from "./filterIcon";
import {
  SelectionCategory,
  SliderCategory,
  CategoryTypeEnum,
} from "./Category";

//Functions and hooks
import { useTranslation } from "react-i18next";
import SvgArrowIcon from "../../SvgIcons/ArrowIcon";
import SvgFilterIcon from "../../SvgIcons/FilterIcon";

export default function Filter({
  categoryArray,
  ConstItems,
  ShowMoreThreshold = 7,
  setNewItems,
  setNewCatArr,
}) {
  const [filterBarCollapsed, setFilterBarCollapsed] = useState(true);
  const containerRef = useRef(null);

  const isDragging = useRef(null);
  const draggingIndex = useRef(null);

  const minToMaxMargin = 0; //Minimal distance between handles in sliders in %

  const [filteredItems, setFilteredItems] = useState(ConstItems);
  const [rangedItems, setRangedItems] = useState(ConstItems);
  const [appliedFilters, setAppliedFilters] = useState(new Map());

  const { t } = useTranslation();

  //Handling clicks off of the filter bar

  useEffect(() => {
    // Function to handle clicks outside the filter-bar-container
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setFilterBarCollapsed(true);
      }
    };

    // Add event listener to detect clicks on the document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  useEffect(() => {
    if (ConstItems.length > 0) setFilteredItems(ConstItems);
  }, [ConstItems]);

  //Handling the slider handamajig movement*************************************************

  /*   const setSliderHandPositions = () => {
    var index = 0;
    categoryArray.forEach((element) => {
      if (element.CategoryType == CategoryTypeEnum.SLIDER) {
        document.getElementById(
          `slider-hand-left-${index}`
        ).style.left = `calc(${valueToPercentage(
          element.sliderMinValue,
          index
        )}%-6px)`;

        document.getElementById(
          `slider-hand-right-${index}`
        ).style.left = `calc(${valueToPercentage(
          element.sliderMaxValue,
          index
        )}%-6px)`;
      }
      index++;
    });
  }; */

  const confirmInputChange = (e, categoryID, hand) => {
    var updatedCatArr = [...categoryArray];

    if (hand == "left") updatedCatArr[categoryID].sliderMinValue = e.value;
    else if (hand == "right")
      updatedCatArr[categoryID].sliderMaxValue = e.value;

    setNewCatArr(updatedCatArr);

    const newSliderValue = valueToPercentage(e.target.value, categoryID);

    moveSliderHand(newSliderValue, categoryID, hand);
    handleFilterChange(false, true, categoryID);
  };
  const handleInputChange = (e, index, hand) => {
    const updatedValue = e.target.value;

    const regex = /^-?\d*\.?\d*$/;

    if (!regex.test(updatedValue)) {
      return;
    }

    var valueText = document.getElementById(`slider-min-value-${index}`);
    var updatedCatArr = [...categoryArray];

    if (hand == "left") {
      valueText = document.getElementById(`slider-min-value-${index}`);
      updatedCatArr[index].sliderInputMinValue = updatedValue;
    } else if (hand == "right") {
      valueText = document.getElementById(`slider-max-value-${index}`);
      updatedCatArr[index].sliderInputMaxValue = updatedValue;
    }

    valueText.value = updatedValue;
    setNewCatArr(updatedCatArr);
  };
  const handleInputKeyPress = (e, categoryID, hand) => {
    if (e.key === "Enter") {
      confirmInputChange(e, categoryID, hand);
    }
  };

  const startDragging = (e, hand, categoryID) => {
    isDragging.current = hand;
    draggingIndex.current = categoryID;
    document.addEventListener("mousemove", moveSliderHandMouseMove);
    document.addEventListener("mouseup", stopDragging);
  };

  const stopDragging = () => {
    handleFilterChange(false, true, draggingIndex.current);
    isDragging.current = null;
    draggingIndex.current = null;
    document.removeEventListener("mousemove", moveSliderHandMouseMove);
    document.removeEventListener("mouseup", stopDragging);
  };

  const moveSliderHandMouseMove = (e) => {
    const index = draggingIndex.current;
    const hand = isDragging.current;
    const rect = document
      .getElementById(`slider-gutter-${index}`)
      .getBoundingClientRect();
    const sliderWidth = rect.width;

    const x = e.clientX - rect.left;
    let percentage = (x / sliderWidth) * 100;
    moveSliderHand(percentage, index, hand);
  };

  const moveSliderHand = (percentage, categoryID, hand) => {
    const sliderLeft = document.getElementById(
      `slider-hand-left-${categoryID}`
    );
    const sliderRight = document.getElementById(
      `slider-hand-right-${categoryID}`
    );

    const minValueText = document.getElementById(
      `slider-min-value-${categoryID}`
    );
    const maxValueText = document.getElementById(
      `slider-max-value-${categoryID}`
    );

    if (hand === "left") {
      // Allow left handle to go 3px beyond the left edge
      const minPercentage = 0;

      const maxValueToShow = valueToPercentage(
        categoryArray[categoryID].sliderMaxValue,
        categoryID
      );

      const valueToShow = Math.max(
        minPercentage,
        Math.min(percentage, maxValueToShow - minToMaxMargin)
      );
      categoryArray[categoryID].sliderMinValue = parseFloat(
        percentageToValue(valueToShow, categoryID)
      ).toFixed(categoryArray[categoryID].decimals);

      sliderLeft.style.left = `calc( ${valueToShow}% - 6px)`;
      categoryArray[categoryID].sliderInputMinValue =
        categoryArray[categoryID].sliderMinValue;
      minValueText.value = categoryArray[categoryID].sliderInputMinValue;
    } else if (hand === "right") {
      const maxPercentage = 100;

      const minValueToShow = valueToPercentage(
        categoryArray[categoryID].sliderMinValue,
        categoryID
      );
      const valueToShow = Math.max(
        minValueToShow + minToMaxMargin,
        Math.min(percentage, maxPercentage)
      );
      categoryArray[categoryID].sliderMaxValue = parseFloat(
        percentageToValue(valueToShow, categoryID)
      ).toFixed(categoryArray[categoryID].decimals);

      sliderRight.style.left = `calc( ${valueToShow}% - 6px)`;
      categoryArray[categoryID].sliderInputMaxValue =
        categoryArray[categoryID].sliderMaxValue;
      maxValueText.value = categoryArray[categoryID].sliderInputMaxValue;
    }
  };

  const percentageToValue = (percentage, categoryID) => {
    const min = parseInt(categoryArray[categoryID].minValue);
    const max = parseInt(categoryArray[categoryID].maxValue);
    if (percentage === 0) return min;
    return parseInt(min) + (percentage / 100) * (max - min);
  };
  const valueToPercentage = (value, categoryID) => {
    return (
      ((value - categoryArray[categoryID].minValue) * 100) /
      (categoryArray[categoryID].maxValue - categoryArray[categoryID].minValue)
    );
  };

  //Filter Bar Stuff**********************************************************************

  useEffect(() => {}, [filterBarCollapsed]);

  const handleFilterClick = () => {
    setFilterBarCollapsed(!filterBarCollapsed);
  };

  const handleCategoryClick = (categoryID) => {
    const updatedCatArr = [...categoryArray];

    updatedCatArr[categoryID].bCategoryCollapsed =
      !updatedCatArr[categoryID].bCategoryCollapsed;

    updatedCatArr[categoryID].bShowMore = false;

    setNewCatArr(updatedCatArr);
  };

  //Selection Category Stuff***************************************************

  const handleItemClick = (categoryID, itemID) => {
    const updatedCatArr = [...categoryArray];
    const newValue = !updatedCatArr[categoryID].ItemArray[itemID].selected;

    updatedCatArr[categoryID].ItemArray[itemID].selected = newValue;

    handleFilterChange(newValue, false, categoryID, itemID);

    setNewCatArr(updatedCatArr);
  };

  const handleFilterChange = (
    selectedNewItem = false,
    selectedNewRange = false,
    categoryID = 0,
    itemID = 0
  ) => {
    const newAppliedFilters = appliedFilters;

    if (!selectedNewRange) {
      if (selectedNewItem)
        categoryArray[categoryID].ItemArray[itemID].selected = true;
      else {
        categoryArray[categoryID].ItemArray[itemID].selected = false;
      }

      if (newAppliedFilters.has(categoryID)) {
        const val = newAppliedFilters.get(categoryID).text1;
        if (!isNaN(val)) {
          if (val === 2 && !selectedNewItem) {
            newAppliedFilters.set(categoryID, {
              name: categoryArray[categoryID].CategoryName,
              type: "sel",
              text1: categoryArray[categoryID].ItemArray.find(
                (obj) => obj.selected === true
              ).ItemName,
            });
          } else {
            newAppliedFilters.set(categoryID, {
              name: categoryArray[categoryID].CategoryName,
              type: "sel",
              text1: selectedNewItem ? val + 1 : val - 1,
            });
          }
        } else {
          if (selectedNewItem) {
            newAppliedFilters.set(categoryID, {
              name: categoryArray[categoryID].CategoryName,
              type: "sel",
              text1: selectedNewItem
                ? 2
                : categoryArray[categoryID].ItemArray[itemID].ItemName,
            });
          } else {
            newAppliedFilters.delete(categoryID);
          }
        }
      } else {
        if (selectedNewItem) {
          newAppliedFilters.set(categoryID, {
            name: categoryArray[categoryID].CategoryName,
            type: "sel",
            text1: categoryArray[categoryID].ItemArray[itemID].ItemName,
          });
        }
      }
    } else {
      const min = categoryArray[categoryID].sliderMinValue;
      const max = categoryArray[categoryID].sliderMaxValue;

      if (
        min === categoryArray[categoryID].minValue &&
        max === categoryArray[categoryID].maxValue
      )
        newAppliedFilters.delete(categoryID);
      else
        newAppliedFilters.set(categoryID, {
          name: categoryArray[categoryID].CategoryName,
          type: "sli",
          text1: min,
          text2: max,
        });
    }

    setAppliedFilters(newAppliedFilters);

    var newItemList = [...ConstItems];
    appliedFilters.forEach((value, key) => {
      if (value.type === "sel") {
        categoryArray[key].ItemArray.forEach((element) => {
          if (element.selected) {
            newItemList = applySelectionFilter(
              key,
              element.ItemName,
              newItemList
            );
          }
        });
      } else {
        newItemList = applySliderFilter(key, newItemList);
      }
    });

    setNewItems(newItemList);
  };

  //Apply a selection filter to the items
  const applySelectionFilter = (CategoryID, ItemName, ItemArray) => {
    const newItemList = ItemArray.filter((element) =>
      categoryArray[CategoryID].ItemHasOption(element, ItemName)
    );

    return newItemList;
  };

  //Apply a slider filter to the items
  const applySliderFilter = (CategoryID, ItemArray) => {
    const min = Number(categoryArray[CategoryID].sliderMinValue);
    const max = Number(categoryArray[CategoryID].sliderMaxValue);
    const newItemList = ItemArray.filter((element) =>
      categoryArray[CategoryID].ItemHasOption(element, min, max)
    );

    return newItemList;
  };

  const handleFilterIconClick = (categoryID) => {
    const newAppliedFilters = appliedFilters;
    const newCatArr = [...categoryArray];
    if (newAppliedFilters.get(categoryID).type === "sel") {
      newCatArr[categoryID].ItemArray.forEach((element) => {
        if (element.selected) element.selected = false;
      });
      newAppliedFilters.delete(categoryID);
      handleFilterChange(false, false, categoryID);
    } else {
      newCatArr[categoryID].sliderMinValue = newCatArr[categoryID].minValue;
      newCatArr[categoryID].sliderMaxValue = newCatArr[categoryID].maxValue;
      newCatArr[categoryID].sliderInputMinValue =
        newCatArr[categoryID].minValue;
      newCatArr[categoryID].sliderInputMaxValue =
        newCatArr[categoryID].maxValue;
      newAppliedFilters.delete(categoryID);
      handleFilterChange(false, true, categoryID);
    }
    setNewCatArr(newCatArr);
  };

  const handleShowMoreClick = (categoryID) => {
    const updatedCatArr = [...categoryArray];

    updatedCatArr[categoryID].bShowMore = !updatedCatArr[categoryID].bShowMore;
    setNewCatArr(updatedCatArr);
  };

  const FixAndCreateCategories = () => {
    console.log("Fix and create categories", categoryArray);
    const fixedCategoryArray = [...categoryArray].filter((element) => {
      return !(
        element.CategoryType === CategoryTypeEnum.SLIDER &&
        element.minValue === element.maxValue
      );
    });
    const createdCategories = fixedCategoryArray.map(CreateCategories);
    return createdCategories;
  };

  const CreateCategories = (item, index) => {
    console.log("Creating category", item);
    if (item.CategoryType === CategoryTypeEnum.SELECTION) {
      return CreateSelectionCategory(item, index);
    } else if (item.CategoryType === CategoryTypeEnum.SLIDER) {
      return CreateSliderCategory(item, index);
    }
  };

  const CreateSelectionCategory = (item, index) => {
    if (item.ItemArray.length > ShowMoreThreshold) {
      item.bMoreToShow = true;
    }

    const itemListToShow = item.bShowMore
      ? item.ItemArray
      : item.ItemArray.slice(0, 6);

    return (
      <li className="category" key={index}>
        <div
          className="categoryHeader"
          onClick={() => {
            handleCategoryClick(index);
          }}
        >
          <p className="categoryName">{t(item.CategoryName)}</p>
          <div className={"categoryArrow"}>
            <SvgArrowIcon className={item.bCategoryCollapsed ? "down" : "up"} />
          </div>
        </div>
        <ul
          className={
            item.bCategoryCollapsed
              ? "categoryItemList collapsed"
              : "categoryItemList"
          }
        >
          {itemListToShow.map((itemInner, indexInner) => {
            return (
              <li
                className="categoryItem checkbox-container"
                key={indexInner}
                onClick={() => handleItemClick(index, indexInner)}
              >
                <p className="categoryItemName">
                  {item.Translate ? t(itemInner.ItemName) : itemInner.ItemName}
                </p>
                <div
                  className={
                    itemInner.selected ? "checkbox checked" : "checkbox"
                  }
                ></div>
              </li>
            );
          })}
          <div
            className={
              item.bMoreToShow ? "categoryShowMore" : "categoryShowMore hidden"
            }
            onClick={() => handleShowMoreClick(index)}
          >
            <div
              className={item.bShowMore ? "showMoreMinus" : "showMorePlus"}
            ></div>
            <p className="showMoreLabel">
              {item.bShowMore ? t("Show Less") : t("Show More")}
            </p>
          </div>
        </ul>
      </li>
    );
  };

  const CreateSliderCategory = (item, index) => {
    return (
      <li className="category" key={index}>
        <div
          className="categoryHeader"
          onClick={() => {
            handleCategoryClick(index);
          }}
        >
          <p className="categoryName">{t(item.CategoryName)}</p>
          <div className={"categoryArrow"}>
            <SvgArrowIcon className={item.bCategoryCollapsed ? "down" : "up"} />
          </div>
        </div>
        <ul
          className={
            item.bCategoryCollapsed
              ? "categoryItemList collapsed"
              : "categoryItemList"
          }
        >
          <li className="categoryItemSlider">
            <div className="sliderLimitContainer">
              <p className="sliderMin">Min: {item.minValue}</p>
              <p className="sliderMax">Max: {item.maxValue}</p>
            </div>
            <div className="sliderContainer">
              <div className="slider" id={`slider-gutter-${index}`}>
                <div className="sliderGutter"></div>
                <div
                  className="sliderHand left"
                  id={`slider-hand-left-${index}`}
                  onMouseDown={(e) => startDragging(e, "left", index)}
                  style={{
                    left: `${
                      ((item.sliderMinValue - categoryArray[index].minValue) *
                        100) /
                        (categoryArray[index].maxValue -
                          categoryArray[index].minValue) -
                      3
                    }%`,
                  }}
                ></div>
                <div
                  className="sliderHand right"
                  id={`slider-hand-right-${index}`}
                  onMouseDown={(e) => startDragging(e, "right", index)}
                  style={{
                    left: `${
                      ((item.sliderMaxValue - categoryArray[index].minValue) *
                        100) /
                        (categoryArray[index].maxValue -
                          categoryArray[index].minValue) -
                      3
                    }%`,
                  }}
                ></div>
              </div>
            </div>

            <div className="sliderLimitContainer">
              <input
                className="sliderMinInput"
                id={`slider-min-value-${index}`}
                value={item.sliderInputMinValue}
                onBlur={(e) => confirmInputChange(e, index, "left")}
                onKeyUp={(e) => handleInputKeyPress(e, index, "left")}
                onChange={(e) => handleInputChange(e, index, "left")}
              ></input>
              <input
                className="sliderMaxInput"
                id={`slider-max-value-${index}`}
                value={item.sliderInputMaxValue}
                onBlur={(e) => confirmInputChange(e, index, "right")}
                onKeyUp={(e) => handleInputKeyPress(e, index, "right")}
                onChange={(e) => handleInputChange(e, index, "right")}
              ></input>
            </div>
          </li>
        </ul>
      </li>
    );
  };

  return (
    <>
      <div
        className={
          filterBarCollapsed ? "filterOverlay collapsed" : "filterOverlay"
        }
      ></div>
      <div
        className={
          filterBarCollapsed
            ? "filter-bar-container collapsed"
            : "filter-bar-container"
        }
        ref={containerRef}
      >
        <ul className="categoryList">{FixAndCreateCategories()}</ul>
      </div>
      <div className="filterContainer">
        <div className="filterButtonContainer">
          <div className="filterButton container">
            <div className="filterImgIcon">
              <SvgFilterIcon />
            </div>
            <div className="filterLabel" onClick={handleFilterClick}>
              {t("Filters")}
            </div>
          </div>
          {/*Creating quick buttons*/}
          {[...categoryArray].map((item, index) => {
            if (item.CategoryType === CategoryTypeEnum.SELECTION) {
              const arrayOfQuicButtons = [...item.ItemArray].map(
                (itemInner, indexInner) => {
                  if (itemInner.quickButton) {
                    return (
                      <Button
                        onClick={() => {
                          handleItemClick(index, indexInner);
                        }}
                        btnSize={"btn-small"}
                        className="ml-2 mr-1"
                        btnBehaviour={"btn-fit"}
                      >
                        {itemInner.ItemName}
                      </Button>
                    );
                  } else return null;
                }
              );
              return arrayOfQuicButtons;
            }
            return null;
          })}
          {/*Creating the applied filter icons*/}
          {[...appliedFilters.keys()].map((CatID) => {
            const filter = appliedFilters.get(CatID);

            var CategoryName = filter.name;
            var Text1 = filter.text1;
            var Text2 = filter.text2;
            var type = filter.type;

            return (
              <FilterIcon
                CategoryID={CatID}
                Type={type === "sel" ? "selection" : "slider"}
                CategoryName={CategoryName}
                Text1={Text1}
                Text2={Text2}
                onClick={handleFilterIconClick}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
